/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeOAuthClientCreatedDto,
  ApiEnvelopeOAuthClientDto,
  ApiEnvelopeOAuthClientListDto,
  ApiEnvelopeOAuthClientNameDto,
  ApiEnvelopeOAuthClientSecretDto,
  ApiEnvelopeOAuthOperationResultDto,
  ApiEnvelopeOAuthRedirectUriDto,
  ApiEnvelopeOAuthRedirectUriListDto,
  OAuthAddRedirectUriRequest,
  OAuthCreateClientRequest,
  OAuthUpdateClientRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type oAuthGetClientNameResponse200 = {
  data: ApiEnvelopeOAuthClientNameDto
  status: 200
}

export type oAuthGetClientNameResponse400 = {
  data: ApiEnvelopeOAuthClientNameDto
  status: 400
}

export type oAuthGetClientNameResponse401 = {
  data: ApiEnvelopeOAuthClientNameDto
  status: 401
}

export type oAuthGetClientNameResponseSuccess = (oAuthGetClientNameResponse200) & {
  headers: Headers;
};
export type oAuthGetClientNameResponseError = (oAuthGetClientNameResponse400 | oAuthGetClientNameResponse401) & {
  headers: Headers;
};

export type oAuthGetClientNameResponse = (oAuthGetClientNameResponseSuccess | oAuthGetClientNameResponseError)

export const getOAuthGetClientNameUrl = (id: string,) => {




  return `/api/OAuth/ClientName/${id}`
}

export const useOAuthGetClientNameHook = (): (id: string, options?: RequestInit) => Promise<oAuthGetClientNameResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getOAuthGetClientNameUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type oAuthGetClientsResponse200 = {
  data: ApiEnvelopeOAuthClientListDto
  status: 200
}

export type oAuthGetClientsResponse400 = {
  data: ApiEnvelopeOAuthClientListDto
  status: 400
}

export type oAuthGetClientsResponse401 = {
  data: ApiEnvelopeOAuthClientListDto
  status: 401
}

export type oAuthGetClientsResponseSuccess = (oAuthGetClientsResponse200) & {
  headers: Headers;
};
export type oAuthGetClientsResponseError = (oAuthGetClientsResponse400 | oAuthGetClientsResponse401) & {
  headers: Headers;
};

export type oAuthGetClientsResponse = (oAuthGetClientsResponseSuccess | oAuthGetClientsResponseError)

export const getOAuthGetClientsUrl = () => {




  return `/api/OAuth/Clients`
}

export const useOAuthGetClientsHook = (): ( options?: RequestInit) => Promise<oAuthGetClientsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getOAuthGetClientsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type oAuthRegenerateClientSecretResponse200 = {
  data: ApiEnvelopeOAuthClientSecretDto
  status: 200
}

export type oAuthRegenerateClientSecretResponse400 = {
  data: ApiEnvelopeOAuthClientSecretDto
  status: 400
}

export type oAuthRegenerateClientSecretResponse401 = {
  data: ApiEnvelopeOAuthClientSecretDto
  status: 401
}

export type oAuthRegenerateClientSecretResponseSuccess = (oAuthRegenerateClientSecretResponse200) & {
  headers: Headers;
};
export type oAuthRegenerateClientSecretResponseError = (oAuthRegenerateClientSecretResponse400 | oAuthRegenerateClientSecretResponse401) & {
  headers: Headers;
};

export type oAuthRegenerateClientSecretResponse = (oAuthRegenerateClientSecretResponseSuccess | oAuthRegenerateClientSecretResponseError)

export const getOAuthRegenerateClientSecretUrl = (clientId: string,) => {




  return `/api/OAuth/Client/${clientId}/NewClientSecret`
}

export const useOAuthRegenerateClientSecretHook = (): (clientId: string, options?: RequestInit) => Promise<oAuthRegenerateClientSecretResponse> => {

      const customFetcher = useSfetchMutator();
      return (clientId: string, options?: RequestInit) => {

        return customFetcher(getOAuthRegenerateClientSecretUrl(clientId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type oAuthGetClientResponse200 = {
  data: ApiEnvelopeOAuthClientDto
  status: 200
}

export type oAuthGetClientResponse400 = {
  data: ApiEnvelopeOAuthClientDto
  status: 400
}

export type oAuthGetClientResponse401 = {
  data: ApiEnvelopeOAuthClientDto
  status: 401
}

export type oAuthGetClientResponse404 = {
  data: ApiEnvelopeOAuthClientDto
  status: 404
}

export type oAuthGetClientResponseSuccess = (oAuthGetClientResponse200) & {
  headers: Headers;
};
export type oAuthGetClientResponseError = (oAuthGetClientResponse400 | oAuthGetClientResponse401 | oAuthGetClientResponse404) & {
  headers: Headers;
};

export type oAuthGetClientResponse = (oAuthGetClientResponseSuccess | oAuthGetClientResponseError)

export const getOAuthGetClientUrl = (clientId: string,) => {




  return `/api/OAuth/Client/${clientId}`
}

export const useOAuthGetClientHook = (): (clientId: string, options?: RequestInit) => Promise<oAuthGetClientResponse> => {

      const customFetcher = useSfetchMutator();
      return (clientId: string, options?: RequestInit) => {

        return customFetcher(getOAuthGetClientUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type oAuthDeleteClientResponse200 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 200
}

export type oAuthDeleteClientResponse400 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 400
}

export type oAuthDeleteClientResponse401 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 401
}

export type oAuthDeleteClientResponseSuccess = (oAuthDeleteClientResponse200) & {
  headers: Headers;
};
export type oAuthDeleteClientResponseError = (oAuthDeleteClientResponse400 | oAuthDeleteClientResponse401) & {
  headers: Headers;
};

export type oAuthDeleteClientResponse = (oAuthDeleteClientResponseSuccess | oAuthDeleteClientResponseError)

export const getOAuthDeleteClientUrl = (clientId: string,) => {




  return `/api/OAuth/Client/${clientId}`
}

export const useOAuthDeleteClientHook = (): (clientId: string, options?: RequestInit) => Promise<oAuthDeleteClientResponse> => {

      const customFetcher = useSfetchMutator();
      return (clientId: string, options?: RequestInit) => {

        return customFetcher(getOAuthDeleteClientUrl(clientId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type oAuthCreateClientResponse200 = {
  data: ApiEnvelopeOAuthClientCreatedDto
  status: 200
}

export type oAuthCreateClientResponse400 = {
  data: ApiEnvelopeOAuthClientCreatedDto
  status: 400
}

export type oAuthCreateClientResponse401 = {
  data: ApiEnvelopeOAuthClientCreatedDto
  status: 401
}

export type oAuthCreateClientResponseSuccess = (oAuthCreateClientResponse200) & {
  headers: Headers;
};
export type oAuthCreateClientResponseError = (oAuthCreateClientResponse400 | oAuthCreateClientResponse401) & {
  headers: Headers;
};

export type oAuthCreateClientResponse = (oAuthCreateClientResponseSuccess | oAuthCreateClientResponseError)

export const getOAuthCreateClientUrl = () => {




  return `/api/OAuth/Client`
}

export const useOAuthCreateClientHook = (): (oAuthCreateClientRequest?: OAuthCreateClientRequest, options?: RequestInit) => Promise<oAuthCreateClientResponse> => {

      const customFetcher = useSfetchMutator();
      return (oAuthCreateClientRequest?: OAuthCreateClientRequest, options?: RequestInit) => {

        return customFetcher(getOAuthCreateClientUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oAuthCreateClientRequest)
  }
);
      }
  }


export type oAuthUpdateClientResponse200 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 200
}

export type oAuthUpdateClientResponse400 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 400
}

export type oAuthUpdateClientResponse401 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 401
}

export type oAuthUpdateClientResponseSuccess = (oAuthUpdateClientResponse200) & {
  headers: Headers;
};
export type oAuthUpdateClientResponseError = (oAuthUpdateClientResponse400 | oAuthUpdateClientResponse401) & {
  headers: Headers;
};

export type oAuthUpdateClientResponse = (oAuthUpdateClientResponseSuccess | oAuthUpdateClientResponseError)

export const getOAuthUpdateClientUrl = () => {




  return `/api/OAuth/Client`
}

export const useOAuthUpdateClientHook = (): (oAuthUpdateClientRequest?: OAuthUpdateClientRequest, options?: RequestInit) => Promise<oAuthUpdateClientResponse> => {

      const customFetcher = useSfetchMutator();
      return (oAuthUpdateClientRequest?: OAuthUpdateClientRequest, options?: RequestInit) => {

        return customFetcher(getOAuthUpdateClientUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oAuthUpdateClientRequest)
  }
);
      }
  }


export type oAuthGetRedirectUrisResponse200 = {
  data: ApiEnvelopeOAuthRedirectUriListDto
  status: 200
}

export type oAuthGetRedirectUrisResponse400 = {
  data: ApiEnvelopeOAuthRedirectUriListDto
  status: 400
}

export type oAuthGetRedirectUrisResponse401 = {
  data: ApiEnvelopeOAuthRedirectUriListDto
  status: 401
}

export type oAuthGetRedirectUrisResponseSuccess = (oAuthGetRedirectUrisResponse200) & {
  headers: Headers;
};
export type oAuthGetRedirectUrisResponseError = (oAuthGetRedirectUrisResponse400 | oAuthGetRedirectUrisResponse401) & {
  headers: Headers;
};

export type oAuthGetRedirectUrisResponse = (oAuthGetRedirectUrisResponseSuccess | oAuthGetRedirectUrisResponseError)

export const getOAuthGetRedirectUrisUrl = (clientId: string,) => {




  return `/api/OAuth/Client/${clientId}/RedirectUris`
}

export const useOAuthGetRedirectUrisHook = (): (clientId: string, options?: RequestInit) => Promise<oAuthGetRedirectUrisResponse> => {

      const customFetcher = useSfetchMutator();
      return (clientId: string, options?: RequestInit) => {

        return customFetcher(getOAuthGetRedirectUrisUrl(clientId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type oAuthAddRedirectUriResponse200 = {
  data: ApiEnvelopeOAuthRedirectUriDto
  status: 200
}

export type oAuthAddRedirectUriResponse400 = {
  data: ApiEnvelopeOAuthRedirectUriDto
  status: 400
}

export type oAuthAddRedirectUriResponse401 = {
  data: ApiEnvelopeOAuthRedirectUriDto
  status: 401
}

export type oAuthAddRedirectUriResponseSuccess = (oAuthAddRedirectUriResponse200) & {
  headers: Headers;
};
export type oAuthAddRedirectUriResponseError = (oAuthAddRedirectUriResponse400 | oAuthAddRedirectUriResponse401) & {
  headers: Headers;
};

export type oAuthAddRedirectUriResponse = (oAuthAddRedirectUriResponseSuccess | oAuthAddRedirectUriResponseError)

export const getOAuthAddRedirectUriUrl = (clientId: string,) => {




  return `/api/OAuth/Client/${clientId}/RedirectUri`
}

export const useOAuthAddRedirectUriHook = (): (clientId: string,
    oAuthAddRedirectUriRequest?: OAuthAddRedirectUriRequest, options?: RequestInit) => Promise<oAuthAddRedirectUriResponse> => {

      const customFetcher = useSfetchMutator();
      return (clientId: string,
    oAuthAddRedirectUriRequest?: OAuthAddRedirectUriRequest, options?: RequestInit) => {

        return customFetcher(getOAuthAddRedirectUriUrl(clientId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(oAuthAddRedirectUriRequest)
  }
);
      }
  }


export type oAuthRemoveRedirectUriResponse200 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 200
}

export type oAuthRemoveRedirectUriResponse400 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 400
}

export type oAuthRemoveRedirectUriResponse401 = {
  data: ApiEnvelopeOAuthOperationResultDto
  status: 401
}

export type oAuthRemoveRedirectUriResponseSuccess = (oAuthRemoveRedirectUriResponse200) & {
  headers: Headers;
};
export type oAuthRemoveRedirectUriResponseError = (oAuthRemoveRedirectUriResponse400 | oAuthRemoveRedirectUriResponse401) & {
  headers: Headers;
};

export type oAuthRemoveRedirectUriResponse = (oAuthRemoveRedirectUriResponseSuccess | oAuthRemoveRedirectUriResponseError)

export const getOAuthRemoveRedirectUriUrl = (clientId: string,
    redirectUriId: string,) => {




  return `/api/OAuth/Client/${clientId}/RedirectUri/${redirectUriId}`
}

export const useOAuthRemoveRedirectUriHook = (): (clientId: string,
    redirectUriId: string, options?: RequestInit) => Promise<oAuthRemoveRedirectUriResponse> => {

      const customFetcher = useSfetchMutator();
      return (clientId: string,
    redirectUriId: string, options?: RequestInit) => {

        return customFetcher(getOAuthRemoveRedirectUriUrl(clientId,redirectUriId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


